import React, { Component } from 'react'
import { connect } from 'react-redux';
import Pagination from 'react-js-pagination'
import './paginations.scss';

class Paginations extends Component {

  goPage(){
    const pageNo = this.refs.pageNo.value;
    const totalSize = _.ceil(this.props.count / this.props.pageSize);
    if(pageNo > totalSize){
      this.props.$$BASE.openToast('输入页码不能超过' + totalSize);
      return;
    }
    if(pageNo < 1){
      this.props.$$BASE.openToast('输入页码不小于1');
      return;
    }
    this.props.action(pageNo)
  }

  render() {
    return (
      <div className='paginations-box'>
        <span>共计{this.props.count}条记录， {_.ceil(this.props.count / this.props.pageSize)}页，当前第{this.props.pageNo}页</span>
        <Pagination 
          activePage={Number(this.props.pageNo)}
          itemsCountPerPage={this.props.pageSize}
          totalItemsCount={this.props.count}
          pageRangeDisplayed={10}
          prevPageText="上页"
          nextPageText="下页"
          firstPageText="首页"
          lastPageText="尾页"
          onChange={(pageNo) => this.props.action(pageNo)}
        />
        <span>转至</span>
        <input type="number" ref='pageNo' />
        <span>页</span>
        <button className='pagination-btn' onClick={() => this.goPage()}>GO</button>
      </div>
    )
  }
}

function mapStateToProps() {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Paginations);
